import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Booking } from '@aps-management/primapp-common';

import masterClient from '_utils/masterClient';

const useSlotLocking = () => {
  const dispatch = useDispatch();
  const lockedSlot = useSelector((state) => state.bookingData.lockedSlot);

  const lockSlot = useCallback(
    async (slot) => {
      if (!slot) {
        throw new Error('NO_SLOT_TO_LOCK');
      }

      const lockStatus = await Booking.api.lockSlot(masterClient, {
        time: slot.time,
        date: slot.date,
        golfId: slot.golfId,
        courseId: slot.courseId,
      });

      dispatch(
        Booking.actions.setLockedSlot({
          golfId: slot.golfId,
          ...lockStatus.lockedSlot,
        }),
      );

      return lockStatus;
    },
    [dispatch],
  );

  const releaseSlot = useCallback(async () => {
    if (!lockedSlot) {
      throw new Error('NO_LOCKED_SLOT');
    }

    const releaseStatus = await Booking.api.releaseSlot(masterClient, {
      time: lockedSlot.time,
      date: lockedSlot.date,
      golfId: lockedSlot.golfId,
      courseId: lockedSlot.courseId,
    });

    dispatch(Booking.actions.setLockedSlot(null));

    return releaseStatus;
  }, [lockedSlot, dispatch]);

  return { lockSlot, releaseSlot };
};

export default useSlotLocking;
